import { render, staticRenderFns } from "./DocumentDetailsNew.vue?vue&type=template&id=c8fdc598"
import script from "./DocumentDetailsNew.vue?vue&type=script&lang=js"
export * from "./DocumentDetailsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports